
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/requests/order/[uuid]",
      function () {
        return require("private-next-pages/requests/order/[uuid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/requests/order/[uuid]"])
      });
    }
  